import {
  TEMPLATE_TESTING_DATA_TYPES,
  TEMPLATE_TESTING_TEST_TYPES,
  TEMPLATE_TESTING_TABS,
  TEMPLATE_TESTING_TEST_VARIABLES_ENTITY_TYPES,
} from '@/constants';

export default {
  filterByRuleType: 'Filter by rule type',
  usePreFilledTemplate: 'Use pre-filled template',
  usePreFilledTemplateWarning: 'Current value will be lost',
  headersHelpText: 'Headers for the HTTP response',
  noHeadersAdded: 'No headers added yet',
  formatJson: 'Format JSON',
  outputPlaceholder: 'Test results will appear here...',
  runTest: 'RUN TEST',
  notRun: 'Not run',
  running: 'Running',
  success: 'Success',
  error: 'Error',
  testVariables: 'Templates Studio',
  testVariablesDisabledTooltip: 'The form doesn\'t have any template fields',
  testFailed: 'Test failed',
  testName: 'Test name',
  testData: 'Test data',
  addData: 'Add data',
  saveTest: 'Save test',
  saveTestAsNew: 'Save as new test',
  errorsInInput: 'Error in input',
  mainFormHasErrors: 'Please fix the errors in the General tab',
  isNewForm: 'If you save this test and the form won\'t be saved, this test will be deleted after closing the creation modal',
  testSaved: 'Template test saved',
  testWillSaveAfterFormSaving: 'Template test will save after form saving',
  lostCurrentTest: {
    text: 'All unsaved changes will be lost for the current test',
    actionText: 'Apply new test data',
    cancelText: 'Keep previous test data',
  },
  requestUrl: 'Request URL - {number}',
  requestPayload: 'Request payload - {number}',
  conditionValue: 'Condition value',
  actionValue: 'Action value - {number}',
  actionAuthor: 'Action author - {number}',
  linkRuleLabel: 'Link rule label - {number}',
  linkRuleUrl: 'Link rule URL - {number}',
  webhookUrl: 'Webhook URL - {number}',
  webhookPayload: 'Webhook payload - {number}',
  webhookHeader: 'Webhook header {header} - {number}',
  noteOutput: 'Note output - {number}',
  widgetContent: 'Widget content',
  widgetTemplate: 'Widget template - {template}',
  columnTemplate: 'Column template - {number}',
  ticketId: 'Ticket ID - {number}',
  ticketUrl: 'Ticket URL - {number}',
  ticketStatusWebhookUrl: 'Ticket status webhook URL - {number}',
  ticketStatusWebhookPayload: 'Ticket status webhook payload - {number}',
  dynamicInfoValue: 'Dynamic info value - {number} - {name}',
  instructionWebhookUrl: 'Instruction webhook URL - Step {step}, Operation {operation}',
  instructionWebhookPayload: 'Instruction webhook payload - Step {step}, Operation {operation}',
  instructionWebhookHeader: 'Instruction webhook header {header} - Step {step}, Operation {operation}',
  instructionJobPayload: 'Instruction job payload - {number}',
  operationDescription: 'Operation description - Step {step}, Operation {operation}',
  jobPayload: 'Job payload',
  jobQueryValue: 'Job query value - {number}',
  metaAlarmOutputTemplate: 'Meta alarm output template',
  metaAlarmComponentTemplate: 'Meta alarm component template',
  metaAlarmResourceTemplate: 'Meta alarm resource template',
  tabs: {
    [TEMPLATE_TESTING_TABS.data]: '@:templateTesting.testData',
    [TEMPLATE_TESTING_TABS.tests]: 'Tests',
  },
  dataTypes: {
    [TEMPLATE_TESTING_DATA_TYPES.event]: 'Event',
    [TEMPLATE_TESTING_DATA_TYPES.response]: 'Response',
  },
  testTypes: {
    [TEMPLATE_TESTING_TEST_TYPES.eventFilter]: 'Event filter',
    [TEMPLATE_TESTING_TEST_TYPES.linkRule]: 'Link rule',
    [TEMPLATE_TESTING_TEST_TYPES.scenario]: 'Action scenario',
    [TEMPLATE_TESTING_TEST_TYPES.widget]: 'Widget',
    [TEMPLATE_TESTING_TEST_TYPES.declareTicketRule]: 'Declare ticket rule',
    [TEMPLATE_TESTING_TEST_TYPES.dynamicInfo]: 'Dynamic info',
    [TEMPLATE_TESTING_TEST_TYPES.instruction]: 'Instruction',
    [TEMPLATE_TESTING_TEST_TYPES.job]: 'Job',
    [TEMPLATE_TESTING_TEST_TYPES.metaAlarmRule]: 'Meta alarm rule',
  },
  templateVars: {
    ackAuthor: 'Ack author',
    ackAuthors: 'Ack authors',
    ackMessage: 'Ack message',
    ackMessages: 'Ack messages',
    actionInitiator: 'Action initiator',
    alarm: 'Alarm',
    alarms: 'Alarms',
    author: 'Author',
    childCount: 'Child count',
    component: 'Component',
    componentInfos: 'Component infos',
    components: 'Components',
    connector: 'Connector',
    connectorName: 'Connector name',
    connectorNames: 'Connector names',
    connectors: 'Connectors',
    consequenceAlarmEntities: 'Consequence alarm entities',
    consequenceAlarms: 'Consequence alarms',
    displayName: 'Display name',
    displayNames: 'Display names',
    email: 'Email',
    entities: 'Entities',
    entity: 'Entity',
    event: 'Event',
    externalData: 'External data',
    externalID: 'External id',
    externalSource: 'External source',
    extraInfos: 'Extra infos',
    firstname: 'Firstname',
    headerField: 'Header field',
    headerFieldFromPreviousSteps: 'Header field from previous step',
    infos: 'Infos',
    initialOutput: 'Initial output',
    initialOutputs: 'Initial outputs',
    lastChildAlarm: 'Last child alarm',
    lastChildEntity: 'Last child entity',
    lastCommentAuthor: 'Last comment author',
    lastCommentAuthors: 'Last comment authors',
    lastCommentMessage: 'Last comment message',
    lastCommentMessages: 'Last comment messages',
    lastname: 'Lastname',
    name: 'Name',
    names: 'Names',
    numberOfAcknowledgedAlarms: 'Number of acknowledged alarms',
    numberOfAcknowledgedAlarmsUnderPbehavior: 'Number of acknowledged alarms under pbehavior',
    numberOfActiveAlarms: 'Number of active alarms',
    numberOfAlarms: 'Number of alarms',
    numberOfAlarmsInCriticalState: 'Number of alarms in Critical state',
    numberOfAlarmsInMajorState: 'Number of alarms in Major state',
    numberOfAlarmsInMinorState: 'Number of alarms in Minor state',
    numberOfAlarmsInOKState: 'Number of alarms in OK state',
    numberOfAlarmsUnderPbehavior: 'Number of alarms under pbehavior',
    numberOfDependencies: 'Number of dependencies',
    numberOfNotAcknowledgedAlarms: 'Number of not acknowledged alarms',
    output: 'Output',
    outputs: 'Outputs',
    regexpMatch: 'Regexp match',
    resource: 'Resource',
    resources: 'Resources',
    responseField: 'Response field',
    responseFieldFromStep: 'Response field from step',
    responseFieldFromPreviousSteps: 'Response field from previous steps',
    responseFieldFromTheStepN: 'Response field from the step #N',
    roleIDs: 'Role ids',
    ruleID: 'Rule id',
    ruleName: 'Rule name',
    stateMessage: 'State message',
    stateMessages: 'State messages',
    stateValue: 'State value',
    stateValues: 'State values',
    statusValue: 'Status value',
    statusValues: 'Status values',
    ticketAuthor: 'Ticket author',
    ticketAuthors: 'Ticket authors',
    ticketID: 'Ticket ID',
    ticketIDs: 'Ticket ids',
    ticketMessage: 'Ticket message',
    ticketMessages: 'Ticket messages',
    trigger: 'Trigger',
    triggerEventMessage: 'Trigger event message',
    type: 'Type',
    types: 'Types',
    user: 'User',
    userID: 'User ID',
    username: 'Username',
    environmentVariables: 'Env',
    rawResponse: 'Raw response',
  },
  testDataLabels: {
    [TEMPLATE_TESTING_TEST_VARIABLES_ENTITY_TYPES.event]: 'Event',
    [TEMPLATE_TESTING_TEST_VARIABLES_ENTITY_TYPES.alarm]: 'Alarm',
    [TEMPLATE_TESTING_TEST_VARIABLES_ENTITY_TYPES.user]: 'User',
    [TEMPLATE_TESTING_TEST_VARIABLES_ENTITY_TYPES.entity]: 'Entity',
    [TEMPLATE_TESTING_TEST_VARIABLES_ENTITY_TYPES.response]: 'Response',
    [TEMPLATE_TESTING_TEST_VARIABLES_ENTITY_TYPES.ticketStatusResponse]: 'Ticket status response',
  },
  testDataResponseLabels: {
    [TEMPLATE_TESTING_TEST_TYPES.eventFilter]: 'Response (External data - {index} API)',
    [TEMPLATE_TESTING_TEST_TYPES.scenario]: 'Response (Action - {index} webhook)',
    [TEMPLATE_TESTING_TEST_TYPES.declareTicketRule]: 'Response (Webhook - {index})',
  },
  testDataCheckTicketStatusResponseLabels: {
    [TEMPLATE_TESTING_TEST_TYPES.declareTicketRule]: 'Check ticket status response (Webhook - {index})',
    [TEMPLATE_TESTING_TEST_TYPES.scenario]: 'Check ticket status response (Action - {index} webhook)',
  },
};
